import { useMemo } from "react";
import { TubeGeometry } from "three";
import type { CenterlineData } from "./useTunnelCenterline";

export function TunnelCenterline({ data, arMode = false }: { data: CenterlineData; arMode?: boolean }) {
  const geometry = useMemo(() => {
    return new TubeGeometry(data.curve, 500, arMode ? 0.25 : 0.15, 6, false);
  }, [data, arMode]);

  return (
    <mesh geometry={geometry}>
      <meshStandardMaterial
        color={arMode ? "#00ffcc" : "#3498db"}
        roughness={0.4}
        metalness={0.2}
        emissive={arMode ? "#00ffcc" : "#000000"}
        emissiveIntensity={arMode ? 0.5 : 0}
      />
    </mesh>
  );
}
